import { sentryCaptureException } from '~/errors/sentry';
import Axios from '~/utils/axios';

export const addReviewReply = async (review_id: string, content: string) => {
   try {
      const { data } = await Axios.post(`/hy-providers/v1/reviews-reply/${review_id}`, {
         content,
      });
      if (data?.status?.toLowerCase() === 'success') {
         return data;
      } else {
         throw new Error(data?.error || data?.original?.error || 'Something went wrong');
      }
   } catch (error: any) {
      sentryCaptureException(error);
      return { error };
   }
};
